import {
  Box,
  Button,
  Grid,
  Td,
  Text,
  Tr,
  VStack
  }
from "@chakra-ui/react";
import React from "react";

import {CandidateStatus} from "../model/Constants";
import {AutomatedCandidateDataDto, CandidateDataDto, CandidateDataIds, CandidateSummaryDto} from "../model/Dto";
import {displayCandidateStatus, displayTime, getLicenseId, getLicenseName} from "../Utils";
import DownloadLicenseCertificate from "./DownloadLicenseCertificate";

type LicenseItemProps = {
  license: CandidateSummaryDto;
  userInstitution: string;
  isPublic?: boolean;
  isAdmin?: boolean;
};

const LicenseItem = (props: LicenseItemProps) => {

  const institution = props.license.institution !== null ? props.license.institution : "";
  const region = props.license.region !== null ? props.license.region : "";
  const institutionDisplay = institution && region ? institution+" - "+region : institution+region

  const userId = getLicenseId(props.license);
  const name = getLicenseName(props.license);

  function calculateCols() {
    const base = 4; /*
                  <Text fontWeight="bold">Prueba</Text>
                  <Text fontWeight="bold">Estado</Text>
                  <Text fontWeight="bold">Inicio-Fin</Text>
                  { !props.isPublic && <Text fontWeight="bold">Banda</Text> }
                  <Text fontWeight="bold">Última pregunta</Text>
                  { !props.isPublic && props.userInstitution==="tweetalig" && <Text fontWeight="bold">Puntaje</Text>}
                                        */
    const notPublic = !props.isPublic ? 1 : 0;
    const notPublicAndTw = !props.isPublic && props.userInstitution==="tweetalig" ? 1 : 0;
    return base + notPublic + notPublicAndTw;
  }

  return (
    <Tr key={props.license.username}>
      <Td>{props.license.username}</Td>
      <Td>{userId}</Td>
      <Td>{name}</Td>
      <Td>{institutionDisplay}</Td>
      <Td>{props.license.userGroup}</Td>
      { !props.isPublic && <Td></Td>/* <Td>{props.license.totalScore}</Td> */}
      { !props.isPublic && <Td></Td>
        /*  <Td>
        <DownloadLicenseCertificate username={props.license.username} name={name}/>
      </Td> */}
        <Td> <VStack align="stretch">
              <Box key={"Box header"}
                p={3}
                bg="gray.50"
                borderRadius="md"
                border="1px solid"
                borderColor="gray.100"
              >
                <Grid templateColumns={`repeat(${calculateCols()}, 1fr)`} placeItems="center" columnGap={2}>
                  <Text fontWeight="bold">Prueba</Text>
                  <Text fontWeight="bold">Estado</Text>
                  <Text fontWeight="bold">Inicio-Fin</Text>
                  { !props.isPublic && <Text fontWeight="bold">Banda</Text> }
                  <Text fontWeight="bold">Última pregunta</Text>
                  { !props.isPublic && props.userInstitution==="tweetalig" && <Text fontWeight="bold">Puntaje</Text>}
                </Grid>
              </Box>
              {props.license.candidates.map((candidate) => (
                <Box
                  key={candidate.testPublicId}
                  bg="gray.50"
                  borderRadius="md"
                  border="1px solid"
                  borderColor="gray.100"
                >
                  <Grid templateColumns={`repeat(${calculateCols()}, 1fr)`} placeItems="center" columnGap={2}>
                    <VStack textAlign="center">
                      <Text>{candidate.testName}</Text>
                      <Text>({candidate.skillType})</Text>
                    </VStack>
                    <Text>{displayCandidateStatus(candidate.status)}</Text>
                    <VStack textAlign="center">
                      <Text>{displayTime(candidate.startTime)}</Text>
                      <Text>{displayTime(candidate.endTime)}</Text>
                    </VStack>
                    { !props.isPublic && <Text>{candidate.level}</Text>}
                    <Text>{candidate.lastAnsweredQuestion}</Text>
                    { !props.isPublic && props.userInstitution==="tweetalig" &&  <Text>{candidate.score}</Text>}
                  </Grid>
                </Box>
            ))}
              {props.license.automatedCandidates.map((candidate) => (
                <Box
                  key={candidate.testPublicId}
                  bg="gray.50"
                  borderRadius="md"
                  border="1px solid"
                  borderColor="gray.100"
                >
                  <Grid templateColumns={`repeat(${calculateCols()}, 1fr)`} placeItems="center" columnGap={2}>
                    <VStack textAlign="center">
                      <Text>{candidate.testName}</Text>
                      <Text>({candidate.skillType})</Text>
                    </VStack>
                    <Text>{displayCandidateStatus(candidate.status)}</Text>
                    <VStack textAlign="center">
                      <Text>{displayTime(candidate.startTime)}</Text>
                      <Text>{displayTime(candidate.endTime)}</Text>
                    </VStack>
                    { !props.isPublic && <Text>{candidate.level}</Text>}
                    { props.isAdmin ? <Text>{candidate.reportUrl}</Text> : <Text></Text>}
                    { !props.isPublic && props.userInstitution==="tweetalig" &&  <Text>{candidate.score}</Text>}
                  </Grid>
                </Box>
            ))}
          </VStack>
        </Td>
    </Tr>
  );
};

export default LicenseItem;
